var _rect, _rect2, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalFeeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.199219,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_11114_52198)",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 15.5,
    stroke: "#0D1A16",
    strokeOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5444 18V22.0326H37.4918V18H39.5444ZM39.2944 40.3228V44H37.2418V40.3228H39.2944ZM40.7418 35.8391C40.7418 35.3197 40.6497 34.8777 40.4655 34.5131C40.29 34.1486 40.0005 33.8251 39.597 33.5426C39.2023 33.2601 38.6672 32.9867 37.9918 32.7224C36.8514 32.2667 35.847 31.7837 34.9786 31.2734C34.119 30.7539 33.4479 30.1115 32.9655 29.346C32.483 28.5713 32.2418 27.5917 32.2418 26.4069C32.2418 25.2769 32.5005 24.2972 33.0181 23.4679C33.5356 22.6386 34.2505 22.0007 35.1628 21.5542C36.0839 21.0985 37.1541 20.8707 38.3734 20.8707C39.3032 20.8707 40.1453 21.0165 40.8997 21.3081C41.6541 21.5906 42.3032 22.0098 42.847 22.5657C43.3909 23.1125 43.8076 23.7823 44.097 24.5752C44.3865 25.368 44.5312 26.2748 44.5312 27.2955H40.7549C40.7549 26.7487 40.6979 26.2657 40.5839 25.8465C40.4698 25.4273 40.3032 25.0764 40.0839 24.7939C39.8734 24.5114 39.619 24.3018 39.3207 24.1651C39.0225 24.0193 38.6935 23.9464 38.3339 23.9464C37.7988 23.9464 37.3602 24.0557 37.0181 24.2744C36.676 24.4932 36.426 24.7893 36.2681 25.163C36.119 25.5275 36.0444 25.9467 36.0444 26.4206C36.0444 26.8854 36.1234 27.2909 36.2812 27.6372C36.4479 27.9835 36.733 28.3025 37.1365 28.5941C37.54 28.8766 38.0927 29.1682 38.7944 29.469C39.9348 29.9246 40.9348 30.4168 41.7944 30.9453C42.6541 31.4739 43.3251 32.1209 43.8076 32.8864C44.29 33.6519 44.5312 34.6271 44.5312 35.8118C44.5312 36.9874 44.2681 37.9898 43.7418 38.8191C43.2155 39.6393 42.4786 40.2681 41.5312 40.7056C40.5839 41.1339 39.4874 41.3481 38.2418 41.3481C37.4348 41.3481 36.6321 41.2387 35.8339 41.02C35.0356 40.7921 34.312 40.4276 33.6628 39.9264C33.0137 39.4252 32.4962 38.7599 32.1102 37.9306C31.7242 37.0922 31.5312 36.0624 31.5312 34.8412H35.3207C35.3207 35.5065 35.4041 36.0624 35.5707 36.5089C35.7374 36.9464 35.9567 37.2972 36.2286 37.5615C36.5093 37.8167 36.8251 37.9989 37.176 38.1083C37.5269 38.2177 37.8821 38.2723 38.2418 38.2723C38.8032 38.2723 39.2637 38.1675 39.6234 37.9579C39.9918 37.7483 40.2681 37.4613 40.4523 37.0967C40.6453 36.7231 40.7418 36.3039 40.7418 35.8391Z",
    fill: "#F2AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0276 18L15.4961 19.5315L22.7427 26.7781L20.7516 28.7693L28.2802 30.7866L26.2629 23.2579L24.2742 25.2466L17.0276 18Z",
    fill: "#02B27F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1245 29.1946L15.3926 30.9265L22.64 38.174L20.75 40.0641L28.2786 42.0814L26.2613 34.5527L24.372 36.442L17.1245 29.1946Z",
    fill: "#02B27F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11114_52198",
    x1: 9.19922,
    y1: 2,
    x2: 60.1992,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFeeLight);
export default __webpack_public_path__ + "static/media/totalFeeLight.e1b7a1722a4b1a9cba484e30450fa5de.svg";
export { ForwardRef as ReactComponent };